/* ============================================================
   table-add-portfolio.js  (Fase 4 · enfoque-free)
   Botón "Añadir a cartera" / "En cartera ✓" en las tablas (radar/ranking/colección).

   - Anónimo            → /pages/onboarding?from=favorito&add={handle} (se siembra como watch).
   - Logueado, ya está  → /pages/mi-cartera (no re-añade, no degrada importes).
   - Logueado, nuevo    → upsert_position (mode watch) vía Make, con el SNAPSHOT COMPLETO
                          de la cartera actual + esta empresa. El snapshot es obligatorio:
                          Make reconstruye el metafield desde `positions` (no hace read-merge),
                          así que enviar una lista parcial borraría posiciones existentes.

   Contexto inyectado por snippets/sr-portfolio-context.liquid:
     window.SR_CUSTOMER_ID, window.SR_PORTFOLIO_WEBHOOKS.upsert_position,
     window.SR_PORTFOLIO_SNAPSHOT = [{ticker, product_gid, handle}, ...]
   ============================================================ */
(function () {
  'use strict';
  if (window._tableAddPortfolioInit) return;
  window._tableAddPortfolioInit = true;

  injectStyles();

  // Captura: corre antes del onclick inline del <td> (event.stopPropagation()).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.btn-add-portfolio');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    handleAdd(btn);
  }, true);

  function miCarteraUrl(btn) { return (btn && btn.dataset.miCarteraUrl) || '/pages/mi-cartera'; }

  function isAdded(btn) {
    var cell = btn.closest('.portfolio-cell, .fav-cell');
    return btn.classList.contains('btn-add-portfolio--added') ||
           (cell && cell.dataset.inPortfolio === 'true');
  }

  function handleAdd(btn) {
    var handle = btn.dataset.handle || '';

    // 1) Anónimo → onboarding con el ticker precargado (watch).
    if (btn.dataset.customerLoggedIn !== 'true') {
      window.location.href = '/pages/onboarding?from=favorito&add=' + encodeURIComponent(handle);
      return;
    }

    // 2) Ya en cartera → a Mi cartera, sin reescribir.
    if (isAdded(btn)) {
      window.location.href = miCarteraUrl(btn);
      return;
    }

    var ticker = btn.dataset.ticker || '';
    var productGid = btn.dataset.productGid || '';
    var customerId = (window.SR_CUSTOMER_ID || btn.dataset.customerId || '').toString().replace(/[^0-9]/g, '');
    var webhooks = window.SR_PORTFOLIO_WEBHOOKS || {};
    var webhook = (webhooks.upsert_position || btn.dataset.webhookUpsert || '').trim();
    var snapshot = Array.isArray(window.SR_PORTFOLIO_SNAPSHOT) ? window.SR_PORTFOLIO_SNAPSHOT.slice() : null;

    // 3) Sin contexto seguro (snapshot/webhook/customer) NO escribimos directo —
    //    un upsert parcial podría borrar la cartera. Caemos al onboarding, que guarda
    //    con el snapshot completo desde portfolio.js.
    if (!webhook || !customerId || snapshot === null) {
      window.location.href = '/pages/onboarding?from=favorito&add=' + encodeURIComponent(handle);
      return;
    }

    // 4) Logueado + nuevo: upsert watch con snapshot completo (existentes + esta).
    var already = snapshot.some(function (p) { return (p.ticker || '').toUpperCase() === ticker.toUpperCase(); });
    if (!already) snapshot.push({ ticker: ticker, product_gid: productGid, handle: handle });

    setAdded(btn, true);
    syncAll(btn.dataset.productId, true);
    btn.disabled = true;

    fetch(webhook, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'upsert_position',
        customer_id: customerId,
        ticker: ticker,
        product_gid: productGid,
        transactions: [],
        net_shares: 0,
        avg_price: 0,
        invested: 0,
        mode: 'watch',
        positions: snapshot
      })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      // Persistimos el nuevo estado en el snapshot global para próximos clics en esta página.
      window.SR_PORTFOLIO_SNAPSHOT = snapshot;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'add_to_portfolio', source: 'table', ticker: ticker, mode: 'watch' });
    })
    .catch(function () {
      // Revertir UI en error.
      setAdded(btn, false);
      syncAll(btn.dataset.productId, false);
    })
    .finally(function () { btn.disabled = false; });
  }

  function setAdded(btn, added) {
    var cell = btn.closest('.portfolio-cell, .fav-cell');
    if (cell) cell.dataset.inPortfolio = added ? 'true' : 'false';
    btn.classList.toggle('btn-add-portfolio--added', added);
    btn.setAttribute('aria-label', added ? 'Ya en tu cartera' : 'Añadir a cartera');
    var icon = btn.querySelector('.btn-add-portfolio__icon');
    var text = btn.querySelector('.btn-add-portfolio__text');
    if (icon) icon.innerHTML = added ? '&#10003;' : '&#43;';
    if (text) text.textContent = added ? 'En cartera' : 'Añadir';
  }

  // Sincroniza todas las instancias del mismo producto en la página.
  function syncAll(productId, added) {
    if (!productId) return;
    document.querySelectorAll('.btn-add-portfolio[data-product-id="' + productId + '"]').forEach(function (b) {
      setAdded(b, added);
    });
  }

  function injectStyles() {
    if (document.getElementById('sr-add-portfolio-styles')) return;
    var css = ''
      + '.btn-add-portfolio{display:inline-flex;align-items:center;gap:.4rem;white-space:nowrap;'
      + 'border:1px solid #5a4a3f;background:#fff;color:#5a4a3f;border-radius:999px;'
      + 'padding:.4rem .9rem;font-size:1.2rem;font-weight:600;line-height:1;cursor:pointer;'
      + 'transition:background .15s,color .15s,border-color .15s;}'
      + '.btn-add-portfolio:hover{background:#5a4a3f;color:#fff;}'
      + '.btn-add-portfolio__icon{font-size:1.3rem;font-weight:700;}'
      + '.btn-add-portfolio--added{background:#15803d;border-color:#15803d;color:#fff;}'
      + '.btn-add-portfolio--added:hover{background:#126b34;border-color:#126b34;color:#fff;}'
      + '.btn-add-portfolio[disabled]{opacity:.6;cursor:default;}'
      + '.th-sticky-cartera .cartera-header-label{font-size:1.3rem;font-weight:600;}'
      + '@media(max-width:749px){.btn-add-portfolio__text{display:none;}'
      + '.btn-add-portfolio{padding:.5rem .7rem;}}';
    var style = document.createElement('style');
    style.id = 'sr-add-portfolio-styles';
    style.textContent = css;
    document.head.appendChild(style);
  }
})();
